export default __webpack_public_path__ + "static/media/exp-date.77b80903.svg";